import { DateFormat } from '@equip.health/ui';
import { DateTime } from 'luxon';

export const hasFutureClosedDate = (closedDate: string): boolean => {
  return !!closedDate && new Date(closedDate).getTime() > Date.now();
};

const sortByDateDescending = (a: string, b: string) =>
  DateTime.fromFormat(b, DateFormat.shortYearMonthDay).toMillis() -
  DateTime.fromFormat(a, DateFormat.shortYearMonthDay).toMillis();

export const getLastTreatmentEpisodeClosedDate = (
  treatmentEpisodes: TreatmentEpisode[],
): string =>
  treatmentEpisodes
    ?.slice()
    .sort(({ closedDate: a }, { closedDate: b }) =>
      sortByDateDescending(a, b),
    )[0]?.closedDate;
